
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { Full_ROUTES } from './shared/routes/full-layout.routes';
import { CONTENT_ROUTES } from './shared/routes/content-layout.routes';
import { DssLayoutComponent } from './layouts/dss/dss-layout.component';
import { FullLayoutComponent } from './layouts/full/full-layout.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { AuthGuard } from './shared/auth/auth-guard.service';
import { InvalidRouteComponent } from './guard/invalid-route.component';

export const APP_TITLE = "Sistemas de Gestão";

const appRoutes: Routes = [
  { path: 'whatsapp-embed', loadComponent: () => import('./pages/whatsapp-embed/whatsapp-embed.component').then(m => m.WhatsappEmbedComponent) },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '', component: FullLayoutComponent, data: { title: APP_TITLE }, children: Full_ROUTES, canActivate: [AuthGuard] },
  { path: '', component: ContentLayoutComponent, data: { title: APP_TITLE }, children: CONTENT_ROUTES },
  { path: 'dss', component: DssLayoutComponent, data: { title: 'Design System Sigma' }, children: [
    { path: '', loadChildren: () => import('./design-system-sigma/dss.module').then(m => m.DssModule) }
  ]},
  { path: '**', component: InvalidRouteComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
